module.exports = __webpack_public_path__ + "img/1.c5637d6d.png";